var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,91.1c-2.4-1-5-1.8-7.2-3c-4.8-2.6-9.5-5.3-14.1-8.2c-0.9-0.6-1.8-2.1-1.7-3.1c0.1-0.8,1.5-1.7,2.5-2.2 C4,74,6.6,72,7,71.8c3.1-1.7,6.2-4.4,9.4-6c1.2-0.6,2.6-0.8,3.5,0.6c0.8,1.3,0.3,2.6-0.8,3.5c-2.2,1.9-4.5,3.7-7.1,5.8 c2.7,0.2,5,0.6,7.4,0.6c14.2,0.2,27.5-3.5,40.4-9c6-2.6,11.7-5.8,16.9-9.8c10.2-7.9,15.5-18.7,18-31c0.5-2.7,0.7-5.4,1.3-8 c0.2-0.8,0.9-2,1.8-2c0.9,0,1.9,1.3,1.8,1.9c-0.2,3.4-0.4,6.9-1,10.3c-3.4,17.8-13.4,30.7-29.3,39.2C55.1,75.2,40,80.1,23.9,80.9 c-4.2,0.2-8.5,0-12.6,0c4.1,2.8,9,5.2,12.2,9.5C23.8,90.9,24,91.3,23,91.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageArrow);
export default __webpack_public_path__ + "static/media/homepage-arrow.2dc412918ef8b57ba8a492e1155f8a88.svg";
export { ForwardRef as ReactComponent };